export default __webpack_public_path__ + "static/media/thermometer.b832e0be.svg";